module.exports = __webpack_public_path__ + "static/img/city-red.c6c0455.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/red-about/city-red.png
// module id = 1054
// module chunks = 173